import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fromLandingPage: false,

}

const landingPageSlice = createSlice({
  name:" lender landing page",

  initialState,
   reducers:{
    setFromLandingPage:(state,action)=>{
      state.fromLandingPage = action.payload;
    }
   }
})

export default landingPageSlice.reducer
export const {setFromLandingPage} =  landingPageSlice.actions;